<div class="backpage-wrapper">
  <div class="home-page-content-container">
    <phx-card class="welcome-card" *ngIf="showCard">
      <button class="close-button" (click)="dismissCard()">
        <mat-icon>close</mat-icon>
      </button>
      <div class="welcome-content">
        <h2>
          Welcome to Allegion License Manager, {{ userProfile?.given_name }}!
        </h2>
        <p class="welcome-description">
          ALM is the location for all your Allegion Digital Products & Services.
          Here you will be able to manage your subscriptions, track usage,
          transfer digital inventory, and more.
        </p>
      </div>
    </phx-card>
    <ng-container
      *ngIf="
        ((isExternalUser && hasCompany) ||
          isInternalUser ||
          isZentraWholesaler) &&
        !isTechSupportExternalUser
      "
    >
      <div class="act-subs-cred-library">
        <div class="credential-library-container padding s6 all">
          <div class="header">
            <h1>Credential Library</h1>
          </div>
          <div
            class="cred-item-container"
            *ifPermissions="[
              'Mobile Cred View',
              'Mobile Cred Support',
              'Internal Admin'
            ]"
          >
            <a class="clickable-card" routerLink="/nfc-mobile-credentials">
              <phx-card class="left-side-card padding s6 all">
                <img
                  src="../../../assets/Logos/NFCLogo.png"
                  alt="credential logo"
                  class="credential-logo"
                />
                <h2>NFC Mobile Credentials</h2>
              </phx-card>
            </a>
            <div class="view-info-button-container padding s6 all">
              <button
                mat-stroked-button
                class="custom-view-info-button"
                routerLink="/nfc-mobile-credentials"
              >
                View Info
              </button>
            </div>
          </div>
          <div
            class="cred-item-container"
            *ifPermissions="[
              'Engage Transfer',
              'Engage View',
              'Engage Support',
              'Internal Admin'
            ]"
          >
            <a
              class="clickable-card"
              routerLink="/engage-schlage-mobile-access-credentials"
            >
              <phx-card class="left-side-card padding s6 all">
                <img
                  class="credential-logo"
                  src="../../../assets/Logos/engagelogonobg 2.svg"
                  alt="engage logo"
                />
                <h2>Schlage Mobile Access Credential with ENGAGE&trade;</h2>
              </phx-card>
            </a>
            <div class="view-info-button-container padding s6 all">
              <button
                mat-stroked-button
                class="custom-view-info-button"
                routerLink="/engage-schlage-mobile-access-credentials"
              >
                View Info
              </button>
            </div>
          </div>
          <div
            class="cred-item-container"
            *ifPermissions="['API View', 'API Support', 'Internal Admin']"
          >
            <a class="clickable-card" routerLink="/BLE-API-credentials">
              <phx-card class="left-side-card padding s6 all">
                <img
                  class="credential-logo"
                  src="../../../assets/Logos/BLE LOGO.svg"
                  alt="ble logo"
                />
                <h2>Schlage Mobile Bluetooth Credential API/SDK</h2>
              </phx-card>
            </a>
            <div class="view-info-button-container padding s6 all">
              <button
                mat-stroked-button
                class="custom-view-info-button"
                routerLink="/BLE-API-credentials"
              >
                View Info
              </button>
            </div>
          </div>
          <div class="cred-item-container" *ngIf="!isCredLibraryUser">
            <phx-card class="left-side-card padding s6 all">
              <img
                class="credential-logo"
                src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
                alt="orange explanation point"
              />
              <h2>No Active Credential Products Found</h2>
            </phx-card>
            <div class="view-info-button-container padding s6 all"></div>
          </div>
        </div>

        <div class="active-subs-container padding s6 all">
          <div class="header">
            <h1>Subscriptions</h1>
            <div class="sub-buttons">
              <button
                *ifPermissions="[
                  'Subscription View For Integrator',
                  'Subscription View For GuestPurchaser'
                ]"
                mat-flat-button
                color="primary"
                routerLink="/zentra-integrator"
                (click)="onCreateSubscription()"
              >
                Create Subscription
              </button>
              <button
                mat-button
                class="submit-ticket-button"
                routerLink="/all-subscriptions"
              >
                View All Subscriptions
              </button>
            </div>
          </div>
          <ng-container *ngIf="preconfiguredSub.length > 0">
            <div
              class="sub-item-container"
              *ngFor="let sub of preconfiguredSub"
              (click)="onReviewClick(sub)"
            >
              <phx-card class="left-side-card padding s6 all">
                <img
                  class="credential-logo"
                  src="../../../assets/Icons/Red Error Exclamation (2).png"
                  alt="red error icon"
                />
                <h2 class="review-text">
                  Subscription Pending - {{ sub.subscriptionIdentifier }}
                </h2>
              </phx-card>
              <div class="view-info-button-container padding s6 all">
                <button
                  mat-stroked-button
                  class="custom-view-info-button"
                  (click)="onReviewClick(sub)"
                >
                  Review
                </button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="activeSubs.length > 0">
            <div
              class="sub-item-container"
              *ngFor="let sub of activeSubs"
              (click)="goToSubscription(sub)"
            >
              <phx-card class="left-side-card padding s6 all">
                <img
                  class="credential-logo"
                  src="../../../assets/Logos/zentra_logo-removebg-preview 1.png"
                  alt="zentra logo"
                />
                <h2>Zentra - {{ sub.property_name }}</h2>
                <span
                  class="status-badge"
                  [ngClass]="{
                    'status-active': sub.maxio_subscription_status === 'Active',
                    'status-canceled':
                      sub.maxio_subscription_status === 'Canceled'
                  }"
                >
                  {{ sub.maxio_subscription_status }}
                </span>
              </phx-card>
              <div class="view-info-button-container padding s6 all">
                <button
                  mat-stroked-button
                  class="custom-view-info-button"
                  [routerLink]="['/active-subscription']"
                  [queryParams]="{ maxioSubId: sub.maxio_subscription_Id }"
                >
                  View Info
                </button>
              </div>
            </div>
          </ng-container>

          <ng-container>
            <div
              class="sub-item-container"
              *ngIf="preconfiguredSub.length === 0 && activeSubs.length === 0"
            >
              <phx-card class="left-side-card padding s6 all">
                <img
                  class="credential-logo"
                  src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
                  alt="orange explanation point"
                />
                <h2>No Subscriptions Found</h2>
              </phx-card>
              <div class="view-info-button-container padding s6 all"></div></div
          ></ng-container>
        </div>
      </div>
      <div class="act-subs-cred-library">
        <div class="credential-library-container-support padding s6 all">
          <div class="header">
            <h1>Need Support?</h1>
            <button
              mat-button
              class="submit-ticket-button"
              routerLink="/support-ticket"
            >
              Submit Ticket
            </button>
          </div>
          <div class="support-text">
            <phx-card class="padding s6 all">
              <h2 class="mat-body-1">
                Fill out a support ticket with as much detail as possible and
                one of our dedicated support staff will assist you promptly, as
                your issue is important to us.
              </h2>
            </phx-card>
          </div>
        </div>
        <div
          class="credential-library-container-support padding s6 all"
          *ngIf="isZentraWholesaler"
        >
          <div class="header">
            <h1>Partner Management</h1>
            <button
              mat-button
              class="submit-ticket-button"
              routerLink="/partner-mgmt"
            >
              Manage
            </button>
          </div>
          <div class="support-text">
            <phx-card class="padding s6 all">
              <h2 class="mat-body-1">
                Invite Guest Purchasers to participate in revenue share and/or
                manage permissions.
              </h2>
            </phx-card>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isTechSupportExternalUser">
      <div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to an external role - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        !isInternalUser &&
        isExternalUser &&
        !hasCompany &&
        !isTechSupportExternalUser
      "
    >
      <div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="50"
            height="50"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to a valid company - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container>
  </div>
</div>
